import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { LinkContainer } from "react-router-bootstrap";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useAuth } from "./../util/auth.js";
import Button from 'react-bootstrap/Button'

import './NavbarCustom.scss'

function NavbarCustom(props) {
  const auth = useAuth();

  return (
    <Navbar className="px-4" style={{height: "100px"}} bg={props.bg} variant={props.variant} expand={props.expand}>
      <a href="https://company.sutra.fit">
        <Navbar.Brand>
          <div>
            <img
              className="d-inline-block align-top"
              src={props.logo}
              alt="Logo"
              height="40"
            ></img>
          </div>
          
        </Navbar.Brand>
      </a>

      <Navbar.Toggle
        aria-controls="navbar-nav"
        className="border-0"
      ></Navbar.Toggle>

      <Navbar.Collapse id="navbar-nav" className="justify-content-end">
        {/* <Nav>
          <Nav.Link href="https://company.sutra.fit/partners" className="p-3" >List my Class</Nav.Link>
          <Button id='nav-button' href="https://sutrafitness.app.link/7HUbJI2wA4" className="ml-3 p-3" variant="primary">DOWNLOAD NOW</Button>
        </Nav> */}
        <Nav>
          {auth.user && (
            <NavDropdown id="dropdown" title="Account" alignRight={true}>
              {auth.userData && auth.userData.isInstructor && (
                <LinkContainer to="/dashboard">
                  <NavDropdown.Item>Dashboard</NavDropdown.Item>
                </LinkContainer>
              )}

              <LinkContainer to="/signout">
                <NavDropdown.Item
                  onClick={e => {
                    e.preventDefault();
                    auth.signout();
                  }}
                >
                  Sign out
                </NavDropdown.Item>
              </LinkContainer>
            </NavDropdown>
          )}

          {!auth.user && (
            <Nav.Item>
              <LinkContainer to="/signin">
                <Nav.Link>Sign in</Nav.Link>
              </LinkContainer>
            </Nav.Item>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavbarCustom;
